var _path, _path2, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChampionbage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 114,
    viewBox: "0 0 101 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.0632 25.0992C98.3685 27.8568 100.973 32.6175 100.973 37.7302V79.7969C100.973 85.4098 97.839 90.553 92.8511 93.1269L57.3648 111.438C53.0495 113.665 47.9232 113.665 43.6079 111.438L8.12155 93.1269C3.13362 90.553 0 85.4098 0 79.7969V37.7302C0 32.6175 2.60418 27.8568 6.90947 25.0992L42.3958 2.3692C47.3271 -0.78941 53.6456 -0.789406 58.5769 2.3692L94.0632 25.0992Z",
    fill: "url(#paint0_linear_222_3)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_222_3",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 101,
    height: 114
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0632 25.0989C98.3685 27.8566 100.973 32.6172 100.973 37.73V79.7977C100.973 85.4105 97.839 90.5537 92.8511 93.1276L57.3648 111.439C53.0495 113.666 47.9232 113.666 43.6079 111.439L8.12155 93.1276C3.13362 90.5537 0 85.4105 0 79.7977V37.73C0 32.6172 2.60418 27.8566 6.90947 25.0989L42.3958 2.36895C47.3271 -0.789654 53.6456 -0.78965 58.5769 2.36896L94.0632 25.0989Z",
    fill: "#FCA326"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_222_3)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: -20.0137,
    y: -30.0098,
    width: 141,
    height: 96
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(10px)",
      clipPath: "url(#bgblur_0_222_3_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_222_3)",
    "data-figma-bg-blur-radius": 20
  }, /*#__PURE__*/React.createElement("rect", {
    width: 101,
    height: 56,
    rx: 28,
    transform: "matrix(1 0 0 -1 -0.0136719 45.9902)",
    fill: "white",
    fillOpacity: 0.05,
    shapeRendering: "crispEdges"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_222_3)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_222_3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.9863 51.9902C60.3752 51.9902 67.9863 59.6014 67.9863 68.9902V106.99C67.9863 116.379 60.3752 123.99 50.9863 123.99C41.5975 123.99 33.9863 116.379 33.9863 106.99V68.9902C33.9863 59.6014 41.5975 51.9902 50.9863 51.9902ZM50.582 61.9902C45.4405 61.9902 41.2725 66.1583 41.2725 71.2998V92.6807C41.2725 97.8222 45.4405 101.99 50.582 101.99C55.7233 101.99 59.8906 97.822 59.8906 92.6807V71.2998C59.8906 66.1585 55.7233 61.9905 50.582 61.9902Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M50.9863 51.9902C60.3752 51.9902 67.9863 59.6014 67.9863 68.9902V106.99C67.9863 116.379 60.3752 123.99 50.9863 123.99C41.5975 123.99 33.9863 116.379 33.9863 106.99V68.9902C33.9863 59.6014 41.5975 51.9902 50.9863 51.9902ZM50.582 61.9902C45.4405 61.9902 41.2725 66.1583 41.2725 71.2998V92.6807C41.2725 97.8222 45.4405 101.99 50.582 101.99C55.7233 101.99 59.8906 97.822 59.8906 92.6807V71.2998C59.8906 66.1585 55.7233 61.9905 50.582 61.9902Z",
    fill: "url(#paint1_linear_222_3)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.582 61.9902L50.5821 61.2402H50.582V61.9902ZM50.582 101.99V102.74H50.5821L50.582 101.99ZM50.9863 51.9902V52.7402C59.961 52.7402 67.2363 60.0156 67.2363 68.9902H67.9863H68.7363C68.7363 59.1872 60.7894 51.2402 50.9863 51.2402V51.9902ZM67.9863 68.9902H67.2363V106.99H67.9863H68.7363V68.9902H67.9863ZM67.9863 106.99H67.2363C67.2363 115.965 59.961 123.24 50.9863 123.24V123.99V124.74C60.7894 124.74 68.7363 116.793 68.7363 106.99H67.9863ZM50.9863 123.99V123.24C42.0117 123.24 34.7363 115.965 34.7363 106.99H33.9863H33.2363C33.2363 116.793 41.1833 124.74 50.9863 124.74V123.99ZM33.9863 106.99H34.7363V68.9902H33.9863H33.2363V106.99H33.9863ZM33.9863 68.9902H34.7363C34.7363 60.0156 42.0117 52.7402 50.9863 52.7402V51.9902V51.2402C41.1833 51.2402 33.2363 59.1872 33.2363 68.9902H33.9863ZM50.582 61.9902V61.2402C45.0263 61.2402 40.5225 65.7441 40.5225 71.2998H41.2725H42.0225C42.0225 66.5725 45.8547 62.7402 50.582 62.7402V61.9902ZM41.2725 71.2998H40.5225V92.6807H41.2725H42.0225V71.2998H41.2725ZM41.2725 92.6807H40.5225C40.5225 98.2364 45.0263 102.74 50.582 102.74V101.99V101.24C45.8547 101.24 42.0225 97.408 42.0225 92.6807H41.2725ZM50.582 101.99L50.5821 102.74C56.1376 102.74 60.6406 98.2362 60.6406 92.6807H59.8906H59.1406C59.1406 97.4079 55.309 101.24 50.582 101.24L50.582 101.99ZM59.8906 92.6807H60.6406V71.2998H59.8906H59.1406V92.6807H59.8906ZM59.8906 71.2998H60.6406C60.6406 65.7443 56.1376 61.2405 50.5821 61.2402L50.582 61.9902L50.582 62.7402C55.309 62.7405 59.1406 66.5726 59.1406 71.2998H59.8906Z",
    fill: "white",
    fillOpacity: 0.2,
    mask: "url(#path-4-inside-1_222_3)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_222_3)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-2_222_3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.9863 48C86.5092 48 90.9863 52.4772 90.9863 58V110C90.9863 115.523 86.5092 120 80.9863 120C75.4635 120 70.9863 115.523 70.9863 110V58C70.9863 52.4772 75.4635 48 80.9863 48ZM80.9863 54C78.7772 54 76.9863 55.7909 76.9863 58V84C76.9863 86.2091 78.7772 88 80.9863 88C83.1955 88 84.9863 86.2091 84.9863 84V58C84.9863 55.7909 83.1955 54 80.9863 54Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M80.9863 48C86.5092 48 90.9863 52.4772 90.9863 58V110C90.9863 115.523 86.5092 120 80.9863 120C75.4635 120 70.9863 115.523 70.9863 110V58C70.9863 52.4772 75.4635 48 80.9863 48ZM80.9863 54C78.7772 54 76.9863 55.7909 76.9863 58V84C76.9863 86.2091 78.7772 88 80.9863 88C83.1955 88 84.9863 86.2091 84.9863 84V58C84.9863 55.7909 83.1955 54 80.9863 54Z",
    fill: "url(#paint2_linear_222_3)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9863 58H91.7363H90.9863ZM90.9863 110H91.7363H90.9863ZM70.9863 110H70.2363H70.9863ZM70.9863 58H70.2363H70.9863ZM76.9863 84H76.2363H76.9863ZM84.9863 58H85.7363H84.9863ZM80.9863 48V48.75C86.095 48.75 90.2363 52.8914 90.2363 58H90.9863H91.7363C91.7363 52.0629 86.9234 47.25 80.9863 47.25V48ZM90.9863 58H90.2363V110H90.9863H91.7363V58H90.9863ZM90.9863 110H90.2363C90.2363 115.109 86.095 119.25 80.9863 119.25V120V120.75C86.9234 120.75 91.7363 115.937 91.7363 110H90.9863ZM80.9863 120V119.25C75.8777 119.25 71.7363 115.109 71.7363 110H70.9863H70.2363C70.2363 115.937 75.0493 120.75 80.9863 120.75V120ZM70.9863 110H71.7363V58H70.9863H70.2363V110H70.9863ZM70.9863 58H71.7363C71.7363 52.8914 75.8777 48.75 80.9863 48.75V48V47.25C75.0493 47.25 70.2363 52.0629 70.2363 58H70.9863ZM80.9863 54V53.25C78.363 53.25 76.2363 55.3766 76.2363 58H76.9863H77.7363C77.7363 56.2051 79.1914 54.75 80.9863 54.75V54ZM76.9863 58H76.2363V84H76.9863H77.7363V58H76.9863ZM76.9863 84H76.2363C76.2363 86.6234 78.363 88.75 80.9863 88.75V88V87.25C79.1914 87.25 77.7363 85.7949 77.7363 84H76.9863ZM80.9863 88V88.75C83.6097 88.75 85.7363 86.6234 85.7363 84H84.9863H84.2363C84.2363 85.7949 82.7813 87.25 80.9863 87.25V88ZM84.9863 84H85.7363V58H84.9863H84.2363V84H84.9863ZM84.9863 58H85.7363C85.7363 55.3766 83.6097 53.25 80.9863 53.25V54V54.75C82.7813 54.75 84.2363 56.2051 84.2363 58H84.9863Z",
    fill: "white",
    fillOpacity: 0.2,
    mask: "url(#path-6-inside-2_222_3)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_222_3)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 48,
    width: 20,
    height: 72,
    rx: 10,
    fill: "url(#paint3_linear_222_3)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.375,
    y: 48.375,
    width: 19.25,
    height: 71.25,
    rx: 9.625,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.75,
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: -4,
    y: -5.31201,
    width: 108.973,
    height: 123.3
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2px)",
      clipPath: "url(#bgblur_1_222_3_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_222_3)",
    "data-figma-bg-blur-radius": 4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.1709 -0.048584C48.8009 -1.73317 52.1718 -1.73317 54.8018 -0.048584L97.2881 27.1653C99.584 28.636 100.973 31.175 100.973 33.9016V84.0637C100.973 87.0571 99.3016 89.8003 96.6416 91.1731L54.1553 113.097C51.8538 114.285 49.1189 114.285 46.8174 113.097L4.33105 91.1731C1.67101 89.8003 2.47609e-05 87.0571 0 84.0637V33.9016C9.87319e-05 31.175 1.38869 28.636 3.68457 27.1653L46.1709 -0.048584ZM54.7949 4.25513C52.1649 2.57053 48.7941 2.57053 46.1641 4.25513L7.6709 28.9114C5.37501 30.3822 3.98633 32.9211 3.98633 35.6477V81.1096C3.98646 84.1029 5.65735 86.8463 8.31738 88.219L46.8105 108.081C49.112 109.269 51.8469 109.269 54.1484 108.081L92.6416 88.219C95.3016 86.8463 96.9725 84.1029 96.9727 81.1096V35.6477C96.9727 32.9211 95.584 30.3822 93.2881 28.9114L54.7949 4.25513Z",
    fill: "black",
    fillOpacity: 0.5,
    shapeRendering: "crispEdges"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_222_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.6937 17.9902L47.3109 21.2293L49.4718 17.9902H45.6937ZM51.0468 17.9902L53.2077 21.2293L54.8249 17.9902H51.0468ZM50.2593 18.3287L48.0468 21.6465H52.4718L50.2593 18.3287ZM44.9202 18.3352L42.1602 21.6465H46.5749L44.9202 18.3352ZM55.5984 18.3352L53.9437 21.6465H58.3593L55.5984 18.3352ZM42.0477 22.4902L47.4843 30.6465H49.9312L46.9593 22.4902H42.0477ZM47.864 22.4902L50.2593 29.0855L52.6546 22.4902H47.864ZM53.5593 22.4902L50.5874 30.6465H53.0343L58.4718 22.4902H53.5593ZM47.6812 31.4902V33.6465H52.8374V31.4902H47.6812ZM44.503 34.4902L41.9863 38.8965H58.5327L56.0155 34.4902H46.8374H44.503ZM45.7593 36.6465H54.7593V37.4902H45.7593V36.6465Z",
    fill: "url(#paint4_linear_222_3)",
    shapeRendering: "crispEdges"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_222_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.9863 14.9476L48.3906 15.9596C48.3437 15.9839 48.3002 15.9937 48.2601 15.9891C48.2202 15.9842 48.1814 15.9697 48.1436 15.9457C48.1055 15.9211 48.0768 15.8863 48.0574 15.8414C48.0381 15.7965 48.0363 15.7474 48.0521 15.6941L48.4768 13.7967L47.0723 12.5179C47.0328 12.484 47.0067 12.4435 46.9941 12.3964C46.9815 12.3494 46.9843 12.3043 47.0024 12.2612C47.0206 12.2181 47.0448 12.1827 47.075 12.155C47.1054 12.1282 47.1465 12.1101 47.198 12.1005L49.0513 11.9306L49.774 10.1338C49.7939 10.083 49.8226 10.0464 49.8601 10.0239C49.8976 10.0015 49.9397 9.99023 49.9863 9.99023C50.0329 9.99023 50.0751 10.0015 50.1129 10.0239C50.1507 10.0464 50.1793 10.083 50.1986 10.1338L50.9213 11.9306L52.7741 12.1005C52.826 12.1097 52.8672 12.1281 52.8976 12.1555C52.9281 12.1825 52.9524 12.2178 52.9706 12.2612C52.9885 12.3043 52.9911 12.3494 52.9785 12.3964C52.9659 12.4435 52.9398 12.484 52.9003 12.5179L51.4958 13.7967L51.9204 15.6941C51.9369 15.7468 51.9352 15.7957 51.9156 15.8409C51.896 15.8862 51.8671 15.921 51.829 15.9453C51.7915 15.9699 51.7527 15.9845 51.7125 15.9891C51.6727 15.9937 51.6293 15.9839 51.5824 15.9596L49.9863 14.9476Z",
    fill: "url(#paint5_linear_222_3)",
    shapeRendering: "crispEdges"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_222_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113 22.8738L48 -4L73.7937 35.6708C73.7937 35.6708 88.5038 36.9751 96.4921 34.3911C104.576 31.7763 113 22.8738 113 22.8738Z",
    fill: "url(#paint6_linear_222_3)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_222_3",
    x: -20.0137,
    y: -30.0098,
    width: 141,
    height: 96,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_222_3"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_222_3",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_222_3_clip_path",
    transform: "translate(20.0137 30.0098)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 101,
    height: 56,
    rx: 28,
    transform: "matrix(1 0 0 -1 -0.0136719 45.9902)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_222_3",
    x: 23.9863,
    y: 49.9902,
    width: 46,
    height: 84,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_222_3"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_222_3",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_222_3",
    x: 60.9863,
    y: 46,
    width: 32,
    height: 84,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_222_3"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_222_3",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_222_3",
    x: 1,
    y: 46,
    width: 32,
    height: 84,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_222_3"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_222_3",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_222_3",
    x: -4,
    y: -5.31201,
    width: 108.973,
    height: 123.3,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_222_3"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_222_3",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_222_3_clip_path",
    transform: "translate(4 5.31201)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.1709 -0.048584C48.8009 -1.73317 52.1718 -1.73317 54.8018 -0.048584L97.2881 27.1653C99.584 28.636 100.973 31.175 100.973 33.9016V84.0637C100.973 87.0571 99.3016 89.8003 96.6416 91.1731L54.1553 113.097C51.8538 114.285 49.1189 114.285 46.8174 113.097L4.33105 91.1731C1.67101 89.8003 2.47609e-05 87.0571 0 84.0637V33.9016C9.87319e-05 31.175 1.38869 28.636 3.68457 27.1653L46.1709 -0.048584ZM54.7949 4.25513C52.1649 2.57053 48.7941 2.57053 46.1641 4.25513L7.6709 28.9114C5.37501 30.3822 3.98633 32.9211 3.98633 35.6477V81.1096C3.98646 84.1029 5.65735 86.8463 8.31738 88.219L46.8105 108.081C49.112 109.269 51.8469 109.269 54.1484 108.081L92.6416 88.219C95.3016 86.8463 96.9725 84.1029 96.9727 81.1096V35.6477C96.9727 32.9211 95.584 30.3822 93.2881 28.9114L54.7949 4.25513Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_222_3",
    x: 38.9863,
    y: 17.9902,
    width: 22.5464,
    height: 26.9062,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_222_3"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_222_3",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_222_3",
    x: 43.9863,
    y: 9.99023,
    width: 12,
    height: 12,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_222_3"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_222_3",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_222_3",
    x: 38,
    y: -14,
    width: 85,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_222_3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_222_3",
    x1: 82.4226,
    y1: 0.000243597,
    x2: 18.5493,
    y2: 113.108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D08CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E125C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_222_3",
    x1: 67.9863,
    y1: 53.4958,
    x2: 46.3267,
    y2: 126.163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.255809,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.05
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_222_3",
    x1: 90.9863,
    y1: 54.187,
    x2: 62.1606,
    y2: 109.187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.255809,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.05
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_222_3",
    x1: 29.842,
    y1: 48,
    x2: 3.4877,
    y2: 116.673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.255809,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.05
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_222_3",
    x1: 57.9418,
    y1: 20.708,
    x2: 38.0017,
    y2: 26.1527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.215641,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_222_3",
    x1: 52.772,
    y1: 10.7702,
    x2: 45.8288,
    y2: 13.1656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.215641,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_222_3",
    x1: 82.0476,
    y1: 13.9159,
    x2: 72.0341,
    y2: 29.1127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChampionbage);
export default __webpack_public_path__ + "static/media/championbage.0e9b9862dea9f6e1432a1218bfeb3280.svg";
export { ForwardRef as ReactComponent };